import React from 'react';
import Confetti from 'react-confetti';

export default class ConfettiEffect extends React.Component {
  state = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);
  }

  updateSize = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  render() {
    const { width, height } = this.state;

    return (
      <Confetti
        recycle={false}
        colors={[
          '#fcfaff',
          '#f9f5ff',
          '#f4ebff',
          '#ecebfc',
          '#d6bbfb',
          '#a790f4',
          '#785ce0',
          '#6646a4',
          '#6941c6',
          '#53389e',
          '#42307d',
        ]}
        width={width}
        height={height}
        {...this.props}
      />
    );
  }
}
